import { CssBaseline, ThemeProvider } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import StoreContext from './store/context';
import RootStore from './store/store';
import Router from './routes/Router';
import theme from './theme';
import './index.css';

import BackgroundContainer from './components/container/BackgroundContainer';

const App: FC = () => {
  const [rootStore] = useState(
    new RootStore({
      authStorePersistanceKey: 'AuthStore',
    }),
  );

  const [storeHydrated, setStoreHydrated] = useState(false);

  useEffect(() => {
    setTimeout(() => setStoreHydrated(true), 0);
  });

  return (
    <StoreContext.Provider value={rootStore}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {storeHydrated && (
          <BackgroundContainer>
            {storeHydrated && <Router />}
          </BackgroundContainer>
        )}
      </ThemeProvider>
    </StoreContext.Provider>
  );
};

export default App;
